// state is not the application state, only the state this
// reducer is responsible for.
import {FETCH_STATS_RECENT, UPDATE_STAT} from "../constants/ActionTypes";

// Returns a single game object
export default function (state = null, action) {

   switch (action.type) {
      case FETCH_STATS_RECENT:
         const payload = action.payload;

         if (payload) {
            return payload;         // payload is of the form: stats[]
         } else {
            return state;
         }
      default:
         return state;
      case UPDATE_STAT:
         // if game is null, create it.
         if (!action.payload) {
            return state;
         }
         const {userId, gameId, username} = action.payload;

         // if no state, nothing to do
         if (!state) return null;

         // find and update
         for (var i = 0; i < state.length; i++) {
            const stat = state[i];
            if (userId === stat.userId && gameId === stat.gameId) {
               stat.username  = username;
               return [...state];
            }
         }
         return state;
   }
}



// WEBPACK FOOTER //
// ./src/reducers/reducer_recent_stats.js